import type { ApplicationSettings } from "owa-application-settings";
import { getApplicationSettings } from "owa-application-settings";

export function getSettings(): ApplicationSettings["Iframes"] {
    const appSettings = getApplicationSettings("Iframes");
    
    return {
        memoryThreshold: appSettings?.memoryThreshold,
        memoryPreloadThreshold: appSettings?.memoryPreloadThreshold,
        memoryVisibleThreshold: appSettings?.memoryVisibleThreshold,
        memoryPressureThreshold: appSettings?.memoryPressureThreshold,
        backgroundCheckInterval: appSettings?.backgroundCheckInterval,
        evictionGraceCount: appSettings?.evictionGraceCount,
    };
}
